import Joi from "joi";

const userProfile = Joi.object().keys({
  name: Joi.string().required().min(3).max(25).messages({
    "string.empty": "Name is required",
    "string.min": "Name must be greater than 3 characters",
    "string.max": "Name must be less than 25 characters",
  }),
  avatar: Joi.string().required().messages({
    "string.empty": "Avatar is required",
  }),
});

export { userProfile };
